import { ResourceType } from './types';

export default class CropwiseResource {
  id: string
  name: string
  type: ResourceType
  geometry?: any

  constructor(resource_obj: any) {
    this.id = resource_obj.id
    this.name = resource_obj.name
    this.type = resource_obj.type
  }
}

export class CropwiseProduct extends CropwiseResource {

  constructor(product_obj: any) {
    super({ id: product_obj.product_id, name: product_obj.product_name, type: ResourceType.product })
  }
}

export class CropwiseField extends CropwiseResource {
  property_name: string
  property_id: string
  geometry: any
  declared_area: number
  constructor(field_obj: any, property_name?: string) {
    super({ id: field_obj.id, name: field_obj.name, type: ResourceType.field })
    this.property_id = field_obj.property_id
    this.property_name = property_name || ''
    this.geometry = { geometry: field_obj.geometry }
    this.declared_area = field_obj.declared_area
  }
}